export default __webpack_public_path__ + "static/media/truck.c66adc04.svg";